import { LoginDomaUserPayload, LoginDomaUserStep2Payload, SRPResponse, SRP2Response } from 'types/Authentication';

import api from 'utils/api';

export const loginDomauser = (payload: LoginDomaUserPayload) => api.post<SRPResponse>(`login/domauser/srp`, payload);
export const loginDomauserStep2 = (payload: LoginDomaUserStep2Payload) =>
  api.post<SRP2Response>(`login/domauser/srp2`, payload);
